import { FC, ReactNode } from 'react'

import { Typography } from '@/components/ui'
import Spinner from '@/components/ui/spinner/Spinner'

interface IFileProcessPanelProps {
	children: ReactNode
}

const FileProcessPanel: FC<IFileProcessPanelProps> = ({ children }) => {
	return (
		<div className='relative flex flex-col items-center justify-center mx-auto'>
			<Spinner className='!absolute !border-t-blue-500 !border-l-gray-100 !border-r-gray-100 !border-b-gray-100' />
			<Typography variant='text' className='pt-32'>
				{children}
			</Typography>
		</div>
	)
}

export default FileProcessPanel
